<ng-container *transloco="let tr; prefix: 'productCategories'; scope: 'product-categories'">
  <nz-affix [nzOffsetTop]="0">
    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>{{ tr('title') }}</nz-page-header-title>
      <nz-page-header-subtitle>{{ tr('subTitle') }}</nz-page-header-subtitle>
      <nz-page-header-extra>
        <a routerLink="new" nz-button nzType="primary">
          <i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{ 'button.addNew' | transloco}}
        </a>
      </nz-page-header-extra>
    </nz-page-header>
  </nz-affix>

  <nz-collapse nzBordered="false">
    <nz-collapse-panel [nzHeader]="'filters' | transloco" [nzActive]="true">
      <div nz-row [nzGutter]="[16,24]">
        <div nz-col>
          <hx-brand-select [(ngModel)]="filter.brandId" (ngModelChange)="applyFilters()"></hx-brand-select>
        </div>
      </div>
    </nz-collapse-panel>
  </nz-collapse>

  <nz-table [nzLoading]="isTableLoading" #listTable
            [nzTotal]="total"
            [nzPageSize]="limit"
            [nzPageIndex]="page"
            [nzData]="list"
            (nzQueryParams)="onQueryParamsChange($event)"
            [nzFrontPagination]="false">
    <thead>
    <tr>
      <th nzColumnKey="title">{{ tr('column.title') }}</th>
      <th nzColumnKey="type">{{ tr('column.type') }}</th>
      <th nzColumnKey="seq">{{ tr('column.seq') }}</th>
      <th nzColumnKey="brand">{{ tr('column.brand') }}</th>
      <th nzColumnKey="components">{{ tr('column.components') }}</th>
      <th nzWidth="100px">#</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of list">
      <td>
        <i nz-icon [nzType]="data.enabled ? 'check-circle': 'minus-circle'" [nzTwotoneColor]="data.enabled ? '#52c41a' : '#ff4d4f'" nzTheme="twotone"></i>
        {{ data.title | uiLabel }}
      </td>
      <td>{{ data.type }}</td>
      <td>{{ data.seq }}</td>
      <td>{{ data.brand?.title }}</td>
      <td>{{ data.components }}</td>
      <td>
        <nz-button-group>
          <a [routerLink]="data.id + '/edit'" nz-button nzType="primary">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
          </a>
          <button nz-button nzType="default" nzDanger nz-popconfirm
                  [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                  [nzCancelText]="'no1' | transloco"
                  (nzOnConfirm)="remove(data.id)">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </button>
        </nz-button-group>
      </td>
    </tr>
    </tbody>
  </nz-table>
</ng-container>
